import arbitrumOne from '../../images/chains/arbitrumOne.svg';
import base from '../../images/chains/base.svg';
import berachain from '../../images/chains/berachain.svg';
import bsc from '../../images/chains/bsc.svg';
import eth from '../../images/chains/eth.svg';
import opBnb from '../../images/chains/opBnb.svg';
import optimism from '../../images/chains/optimism.svg';
import unichain from '../../images/chains/unichain.svg';
import zkSync from '../../images/chains/zkSync.svg';

export const iconSrcs = {
    arbitrumOne: arbitrumOne,
    base: base,
    berachain: berachain,
    bsc: bsc,
    eth: eth,
    opBnb: opBnb,
    optimism: optimism,
    unichain: unichain,
    zkSync: zkSync,
};
